<template>
  <s-page v-if="shouldShow" :title="pageTitle">
    <!-- Breadcrumb (if not Dashboard) -->
    <s-link
      v-if="showBreadcrumb"
      slot="breadcrumb-actions"
      @click="goHome"
    >
      Home
    </s-link>

    <!-- Primary Action (Save button for edit pages) -->
    <s-button
      v-if="buttonsSet === 'item'"
      variant="primary"
      slot="primary-action"
      @click="handleSave"
    >
      Save
    </s-button>

    <!-- Secondary Actions - Dashboard -->
    <template v-if="buttonsSet === 'dashboard'">
      <s-button slot="secondary-actions" @click="handleImport">Import</s-button>
      <s-button slot="secondary-actions" @click="handleExport">Export</s-button>
      <s-button slot="secondary-actions" @click="handleTutorial">Tutorial</s-button>
      <s-button slot="secondary-actions" @click="handleHelp">Get help</s-button>
      <s-button slot="secondary-actions" @click="handleReview">Leave review</s-button>
    </template>

    <!-- Secondary Actions - Item/HelpOnly -->
    <template v-else-if="buttonsSet === 'item' || buttonsSet === 'helpOnly'">
      <s-button slot="secondary-actions" @click="handleHelp">Get help</s-button>
      <s-button slot="secondary-actions" @click="handleReview">Leave review</s-button>
    </template>
  </s-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ShopifyPage',

  computed: {
    ...mapState('shopifyBar', ['pageTitle', 'buttonsSet', 'visible']),
    ...mapGetters('shopifyBar', ['ready']),

    shouldShow() {
      // Only show if:
      // 1. window.shopify is ready
      // 2. Visible flag is true
      return this.ready && this.visible
    },

    showBreadcrumb() {
      return this.pageTitle !== 'Dashboard'
    }
  },

  methods: {
    goHome() {
      this.$router.push('/')
    },

    handleSave() {
      // Dispatch window event for backward compatibility with existing page listeners
      window.dispatchEvent(new Event('save'))
    },

    handleImport() {
      window.dispatchEvent(new Event('schema_import'))
    },

    handleExport() {
      window.dispatchEvent(new Event('schema_export'))
    },

    handleTutorial() {
      window.dispatchEvent(new Event('show_tutorial'))
    },

    handleHelp() {
      window.open('https://www.airfields.io/', '_blank', 'noopener')
    },

    handleReview() {
      window.open(
        'https://apps.shopify.com/airfields#modal-show=ReviewListingModal',
        '_blank',
        'noopener'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ShopifyPage.vue